module.exports = __webpack_public_path__ + "img/menu_gift1.09a27881.png";